/**
 * XVI UI features names list
 *
 * To add a new feature in addition to adding a name and a config section we need to make changes
 * in the docker configuration.
 * The new feature should be also added into the following files:
 * serverless.yml
 * serverless-environment-schema.yml
 * entrypoint.sh
 * docker-compose.yml (multiple entries)
 * config/set-env.js (multiple entries)
 * README.md
 */
export enum FEATURES {
  BUSINESS_DATE_FLOW_ENABLED = 'BUSINESS_DATE_FLOW_ENABLED',
}

/**
 * Interface which describes XVI UI features
 */
export interface IXVIFeature {
  name: FEATURES;
  description?: string;
  default?: any;
}

export const UI_FEATURES: IXVIFeature[] = [
  {
    name: FEATURES.BUSINESS_DATE_FLOW_ENABLED,
    description: 'Enables adding business calculator headers to requests',
    default: false,
  },
];
